/* eslint-disable @typescript-eslint/no-explicit-any */
import { datadogLogs } from '@datadog/browser-logs';
import { GraphQLError } from 'graphql/error';

export type MultipleErrorTypes = GraphQLError[] | Error[];

const isServer = () => typeof window === 'undefined';

const serverLog = (level: string, msg: string, ctx?: any) => {
  const logData = {
    level,
    message: msg,
    service: 'syn-web',
    ddsource: 'nextjs',
    ddtags: `env:${process.env.NEXT_PUBLIC_DD_ENV || process.env.NODE_ENV || 'development'}`,
    ...(ctx && { context: ctx }),
  };

  const output = JSON.stringify(logData);

  switch (level) {
    case 'error':
      console.error(output);
      break;
    case 'warn':
      console.warn(output);
      break;
    default:
      console.log(output);
  }
};

export const Log = {
  error: (msg: string, ctx?: any) => (isServer() ? serverLog('error', msg, ctx) : datadogLogs.logger.error(msg, ctx)),
  warning: (msg: string, ctx?: any) => (isServer() ? serverLog('warn', msg, ctx) : datadogLogs.logger.warn(msg, ctx)),
  info: (msg: string, ctx?: any) => (isServer() ? serverLog('info', msg, ctx) : datadogLogs.logger.info(msg, ctx)),
  errors: (msg: string, errors: MultipleErrorTypes) => {
    if (isServer()) {
      for (const err of errors) {
        serverLog('error', msg, err);
      }
    } else {
      for (const err of errors) {
        datadogLogs.logger.error(msg, err);
      }
    }
  },
};
